export function formatDuration(seconds?: number): string {
    if (!seconds && seconds !== 0) return "--:--";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}

export function formatHumanDuration(seconds?: number): string {
    if (!seconds && seconds !== 0) return "";
    if (seconds < 60) {
        return `${seconds} sec`;
    }

    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}m ${secs}s`;
}

/** Formats an integer number of seconds as HH:MM:SS (e.g. 3661 → "01:01:01"). */
export function formatDurationHHMMSS(totalSeconds: number): string {
    if (!totalSeconds && totalSeconds !== 0) return "--:--:--";
    const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    const s = String(Math.floor(totalSeconds % 60)).padStart(2, "0");
    return `${h}:${m}:${s}`;
}

/** Formats a ratio (0-1) as percentage string (e.g. 0.219 -> "21,9 %"). */
export function formatPercentageFromRatio(value?: number | null, maximumFractionDigits = 1): string {
    if (value == null || Number.isNaN(Number(value))) return "-";
    return `${(Number(value) * 100).toLocaleString("fr-FR", { maximumFractionDigits })} %`;
}

/** Formats a ratio (0-1) as a normalized percentage string for number inputs. */
export function formatPercentageInputFromRatio(value?: number | null, maximumFractionDigits = 6): string {
    if (value == null || Number.isNaN(Number(value))) return "";
    const percentage = Number(value) * 100;
    return Number(percentage.toFixed(maximumFractionDigits)).toString();
}

/** Parses a percentage input (e.g. 21.9) to ratio (0.219). */
export function parsePercentageInputToRatio(input: string | number | null | undefined): number | undefined {
    if (input == null || input === "") return undefined;
    const parsed = typeof input === "number" ? input : Number(String(input).replace(",", "."));
    if (Number.isNaN(parsed)) return undefined;
    return parsed / 100;
}
